import React from "react";
import { CartContext } from "./CartContext";

export const useCartContext = () => {
  const cartContext = React.useContext(CartContext);

  if (!cartContext) {
    throw new Error("useCartContext must be used within a CartContextProvider");
  }

  return cartContext;
};
